import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { compose } from 'redux';

import ManageProviderOnBoardingScreens from '../../../components/SiteAdmin/ManageProviderOnBoardingScreens/ManageProviderOnBoardingScreens';
import Loader from '../../../components/Common/Loader/Loader';

import messages from '../../../locale/messages';
import { getAllOnBoardingContent } from '../../../lib/graphql';
import { withQuery } from '../../../hoc/withGraphql';

const ProviderOnboardingScreens = ({ getAllOnBoardingContent: { getAllOnBoardingContent, refetch, loading } }) => {
    const { formatMessage } = useIntl();
    const [currentPage, setCurrentPage] = useState(1);

    if (loading) {
        return <Loader type="page" show={loading} />
    }

    return (
        <div>
            <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.providerOnBoardingScreens)}</h1>
            <ManageProviderOnBoardingScreens data={getAllOnBoardingContent} refetch={refetch} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
    );
}

export default compose(
    withQuery(getAllOnBoardingContent, {
        name: 'getAllOnBoardingContent',
        options: {
            variables: {
                currentPage: 1
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    })
)(ProviderOnboardingScreens);
